// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5573ebf0","453":"9bceb96f","732":"5f4a747c"}[chunkId] + ".chunk.js";
};